// Open decision (see external-provider ticket): seed list of common home-care /
// disability-support EHRs. Extend or replace once the business confirms the
// final list. Shared between the Add Provider drawer and the provider
// edit/view form so both stay in sync.
export const EHR_OPTIONS = [
  "Therap",
  "MediSked",
  "Sandata",
  "Netsmart",
  "WellSky",
  "PointClickCare",
  "Other",
];
